
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic07 as ObiHydraulic07Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-07.js';
 
 
 

 
 export const ObiHydraulic07 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-07',
   elementClass: ObiHydraulic07Element,
   events: {
     
   }
  });
 
 